export const styles: any = {
  Img: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 1,
    height: 'inherit'
  }
};
